import { useMemo, useState } from 'react';
import { useBlockEffect } from '@smartfire/js-block-engine';
import apiFetch from '@wordpress/api-fetch';
import { useShallowEqual } from './useShallowEqual';
import { useURLSearchParams } from './useURLSearchParams';

const data = ['category', 'featured', 'lang', 'on_sale', 'orderby', 'order', 'page', 'per_page', 'prices', 'search'];

export const useProducts = (queryProps) => {
    const [products, setProducts] = useState([]);
    const [totalProducts, setTotalProducts] = useState(0);
    const [totalPages, setTotalPages] = useState(0);
    const [loading, setLoading] = useState(true);

    const query = useShallowEqual(queryProps);

    const searchParams = useURLSearchParams();

    const params = useMemo(() => {
        let queryParams = new URLSearchParams();

        data.forEach((dataKey) => {
            if (query[dataKey]) queryParams.set(dataKey, query[dataKey]);
        });

        if (query.include) queryParams.set('include', query.include.join(','));
        if (query.exclude) queryParams.set('exclude', query.exclude.join(','));
        if (query.categories && query.categories.length > 0) {
            query.categories.forEach((category) => {
                queryParams.append('categories[' + category.slug + ']', category.values);
            });
        }
        if (query.attributes && query.attributes.length > 0) {
            query.attributes.forEach((attribute) => {
                queryParams.append('attributes[' + attribute.attribute + ']', attribute.slug);
            });
        }
        if (query.genres && query.genres.length > 0) {
            query.genres.forEach((genre) => {
                queryParams.append('genres', genre.values);
            });
        }
        if (query.sole_type && query.sole_type.length > 0) {
            queryParams.set('sole_type', query.sole_type.join(','));
        }
        if (query.latest && query.latest.length > 0) {
            queryParams.set('latest', true);
        }

        return queryParams;
    }, [query]);

    useBlockEffect(() => {
        const ac = new AbortController();
        setLoading(true);

        apiFetch({
            path: 'smartfire/v1/products/?' + params.toString(),
            parse: false,
            signal: ac.signal,
        })
            .then((response) => {
                setTotalProducts(response.headers.get('X-WP-Total'));
                setTotalPages(response.headers.get('X-WP-TotalPages'));

                response
                    .json()
                    .then((data) => {
                        setProducts(data);
                        setLoading(false);
                    })
                    .catch((e) => {
                        console.error(e);
                    });
            })
            .catch((e) => {
                if (!(e instanceof DOMException) || e.code !== e.ABORT_ERR) {
                    console.error(e);
                }
            });

        return () => ac.abort();
        // eslint-disable-next-line
    }, [params, searchParams]);

    return {
        products,
        totalProducts: parseInt(totalProducts, 10),
        totalPages: parseInt(totalPages, 10),
        productsLoading: loading,
    };
};
